import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { removeToken, getToken } from "../rtkq/services/localStorageService";
import { useGetLoggedUserQuery } from '../rtkq/services/userAuthApi';

export const StudentNav = () => {
  const navigate = useNavigate();
  const { access_token } = getToken();
  const { data } = useGetLoggedUserQuery(access_token);

  const handleLogout = () => {
    removeToken();
    navigate('/login');
  };

  const handleOptionClick = (path) => {
    navigate(path);
  };

  // Check if the user is a student or teacher
  const isStudent = data?.role === 'student';
  const isTeacher = data?.role === 'teacher';

  return (
    <div className="absolute right-0 top-full mt-0 w-48 bg-white rounded-lg shadow-lg z-10">
      <ul className="text-gray-700">
        <li className="px-4 py-2 hover:bg-gray-100 transition duration-200" onClick={() => handleOptionClick('/profile')}>
          <Link to="/profile" className="block">
            Profile
          </Link>
        </li>
        {isStudent && (
          <li className="px-4 py-2 hover:bg-gray-100 transition duration-200" onClick={() => handleOptionClick('/chat')}>
            <Link to="/chat" className="block">
              English Chat
            </Link>
          </li>
        )}
        {isTeacher && (
          <li className="px-4 py-2 hover:bg-gray-100 transition duration-200" onClick={() => handleOptionClick('/student-performance')}>
            <Link to="/student-performance" className="block">
              Student Performance
            </Link>
          </li>
        )}
        <li className="px-4 py-2 hover:bg-gray-100 transition duration-200" onClick={() => handleOptionClick('/leaderboard')}>
          <Link to="/leaderboard" className="block">
            Leaderboard
          </Link>
        </li>
        <li className="px-4 py-2 hover:bg-gray-100 transition duration-200" onClick={handleLogout}>
          <button className="w-full text-left">Logout</button>
        </li>
      </ul>
    </div>
  );
};